/**
* @author Indeform Ltd
* @copyright Copyright 2020, Indeform Ltd
* @version 20200306
* @description Login status component.
*/


import Status from "../status";

class LoginStatus extends Status {
    constructor(ui) {
        super(ui, 'formStatus', [], {
            elmForm: 'formLogin',
            elmStatusError: 'formStatusError',
            elmStatusCode: 'statusCode',
            elmTimer: 'timer',
        });
    }
}

export { LoginStatus }
export default LoginStatus


//////////////////
// WEBPACK FOOTER
// ./dev_js/sso/orthosso/modules/sign/login/login-status.js
// module id = 345
// module chunks = 0